export default __webpack_public_path__ + "resources/icons/n331-fe44.webp";